import * as React from 'react';
import { Store } from 'redux';
import { IndexRedirect, Route } from 'react-router';
import { requireStaff, makeGetComponent } from './utils';

export const getAdminRoute = (store: Store<RootState>) => (
  <Route
    path="admin"
    getComponent={makeGetComponent('Admin/AdminLayout')}
    onEnter={requireStaff(store)}
  >
    <IndexRedirect to="users" />
    <Route
      path="dashboard"
      getComponent={makeGetComponent('Admin/AdminDashboard/AdminDashboard')}
    />
    <Route
      path="users"
      getComponent={makeGetComponent('Admin/AdminUser/AdminUser')}
    />
    <Route
      path="users/:id"
      getComponent={makeGetComponent('Admin/AdminUser/AdminUserTabs')}
    />
    <Route
      path="roles"
      getComponent={makeGetComponent('Admin/AdminRole/AdminRole')}
    />
    <Route
      path="subscription-requests"
      getComponent={makeGetComponent(
        'Admin/SubscriptionRequests/SubscriptionRequestsList'
      )}
    />
    <Route
      path="subscription-requests/create"
      getComponent={makeGetComponent(
        'Admin/SubscriptionRequests/SubscriptionRequestsCreate'
      )}
    />
    <Route
      path="subscription-requests/:id/update"
      getComponent={makeGetComponent(
        'Admin/SubscriptionRequests/SubscriptionRequestsUpdate'
      )}
    />
    <Route
      path="subscription-requests/:id/view"
      getComponent={makeGetComponent(
        'Admin/SubscriptionRequests/SubscriptionRequestsView'
      )}
    />
    <Route
      path="subscription-requests/:id/version/:version/view/invoice"
      getComponent={makeGetComponent(
        'Admin/SubscriptionRequests/InvoiceViewer'
      )}
    />
    <Route
      path="subscription-requests/:id/version/:version/approve"
      getComponent={makeGetComponent(
        'Admin/SubscriptionRequests/SubscriptionRequestsApprove'
      )}
    />
    <Route
      path="subscription-requests/:id/version/:version/reject"
      getComponent={makeGetComponent(
        'Admin/SubscriptionRequests/SubscriptionRequestsReject'
      )}
    />
    <Route
      path="free-trials"
      getComponent={makeGetComponent('Admin/FreeTrials/FreeTrialsList')}
    />
    <Route
      path="free-trials/create"
      getComponent={makeGetComponent('Admin/FreeTrials/FreeTrialsCreate')}
    />
    <Route
      path="free-trials/:id/update"
      getComponent={makeGetComponent('Admin/FreeTrials/FreeTrialsUpdate')}
    />
    <Route
      path="free-trials/:id/view"
      getComponent={makeGetComponent('Admin/FreeTrials/FreeTrialsView')}
    />
    <Route
      path="free-trials/:id/version/:version/approve"
      getComponent={makeGetComponent('Admin/FreeTrials/FreeTrialsApprove')}
    />
    <Route
      path="free-trials/:id/version/:version/activate"
      getComponent={makeGetComponent('Admin/FreeTrials/FreeTrialsActivate')}
    />
    <Route
      path="free-trials/:id/version/:version/reject"
      getComponent={makeGetComponent('Admin/FreeTrials/FreeTrialsReject')}
    />
    <Route
      path="free-trials/:id/version/:version/clone"
      getComponent={makeGetComponent('Admin/FreeTrials/FreeTrialsClone')}
    />
    <Route
      path="price-alerts"
      getComponent={makeGetComponent('Admin/PriceAlert/PriceAlertList')}
    />
    <Route
      path="one-off-requests"
      getComponent={makeGetComponent('Admin/OneOffRequest/List')}
    />
    <Route
      path="one-off-requests/create"
      getComponent={makeGetComponent('Admin/OneOffRequest/Create')}
    />
    <Route
      path="one-off-requests/:id/update"
      getComponent={makeGetComponent('Admin/OneOffRequest/Update')}
    />
    <Route
      path="one-off-requests/:id/delete"
      getComponent={makeGetComponent('Admin/OneOffRequest/Delete')}
    />
    <Route
      path="one-off-requests/:id/view"
      getComponent={makeGetComponent('Admin/OneOffRequest/View')}
    />
    <Route
      path="one-off-requests/:id/approve"
      getComponent={makeGetComponent('Admin/OneOffRequest/Approve')}
    />
    <Route
      path="one-off-requests/:id/reject"
      getComponent={makeGetComponent('Admin/OneOffRequest/Reject')}
    />
    <Route
      path="exchange-rates"
      getComponent={makeGetComponent('Admin/ExchangeRates/ExchangeRatesPage')}
    />
    <Route
      path="exchange-rates/create"
      getComponent={makeGetComponent(
        'Admin/ExchangeRates/ExchangeRateCreatePage'
      )}
    />
  </Route>
);



// WEBPACK FOOTER //
// ./app/routers/AdminRoute.tsx